export default "__VITE_ASSET__DPB8Jf_G__";